const $countriesBtn = $('.m-ilink--countries');
const $countriesCloseBtn = $('.m-countries__close');
const $countriesList = $('.m-countries__menu');

$countriesBtn.add($countriesCloseBtn).click(function () {
    $countriesList.toggleClass('open');
});
